import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Cash(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.47 1a1 1 0 011 1v1.365c2.386.363 4.631 2.016 4.666 4.79a1 1 0 01-.987 1.013c-.527.025-1.006-.434-1.013-.987-.023-1.831-1.812-2.84-3.532-2.89a1.007 1.007 0 01-.275 0l.141-.003c-1.485 0-2.972.11-3.8.902-.713.682-.877 1.818-.383 2.644.643 1.073 2.08 1.556 3.494 1.96l1.566.431c1.574.473 3.285 1.161 4.223 2.727.977 1.632.677 3.783-.715 5.116-.951.912-2.24 1.254-3.385 1.382v1.364a1 1 0 01-2 0v-1.292c-2.663-.084-5.425-1.783-5.465-4.864a1 1 0 01.988-1.012.987.987 0 011.012.987c.024 1.88 1.907 2.893 3.666 2.893 1.485 0 2.973-.109 3.801-.902.712-.682.877-1.819.382-2.644-.585-.978-1.817-1.459-3.06-1.833l-1.553-.428c-1.729-.492-3.652-1.158-4.67-2.858-.977-1.63-.677-3.783.715-5.115 1.183-1.132 2.885-1.385 4.185-1.441V2a1 1 0 011-1z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoCash = React.memo(Cash);
export default MemoCash;